import { Link } from 'react-router-dom';
import { listAgents, listAgentTasks } from './service';
import { useCan, useResource } from './ui';
export function HomeAgencySummary() {
  const canAgents = useCan('agents.view');
  const canReview = useCan('agent_tasks.review');
  const canTasks = useCan('agent_tasks.view');
  const r = useResource(async () => {
    const [agents, pending, tasks] = await Promise.all([
      canAgents ? listAgents({ page: 1, page_size: 1 }) : undefined,
      canReview
        ? listAgentTasks({ review: 'true', page: 1, page_size: 1 })
        : undefined,
      canTasks
        ? listAgentTasks({ page: 1, page_size: 1, status: 'approved' })
        : undefined,
    ]);
    return {
      agents: agents?.total,
      pending: pending?.total,
      tasks: tasks?.total,
    };
  }, [canAgents, canReview, canTasks]);
  if (!canAgents && !canReview && !canTasks) return null;
  return (
    <section className="rounded-[24px] border border-gray-200 bg-white p-5">
      <div className="flex justify-between">
        <h2 className="font-semibold text-gray-900">商户业务</h2>
        <span className="text-xs text-gray-400">
          发布审核独立计数，会员提交仍计入原审核模块
        </span>
      </div>
      {r.error ? (
        <p className="mt-3 text-sm text-red-600">{r.error}</p>
      ) : (
        <div className="mt-4 grid gap-3 md:grid-cols-3">
          {[
            {
              show: canAgents,
              to: '/agents',
              label: '商户总数',
              value: r.data?.agents,
            },
            {
              show: canReview,
              to: '/agent-task-reviews',
              label: '待发布审核任务',
              value: r.data?.pending,
            },
            {
              show: canTasks,
              to: '/agent-tasks?status=approved',
              label: '已批准商户任务',
              value: r.data?.tasks,
            },
          ]
            .filter((x) => x.show)
            .map((x) => (
              <Link key={x.to} to={x.to} className="rounded-xl bg-gray-50 p-4">
                <p className="text-sm text-gray-500">{x.label}</p>
                <p className="mt-2 text-2xl font-semibold text-gray-900">
                  {x.value ?? '—'}
                </p>
              </Link>
            ))}
        </div>
      )}
    </section>
  );
}
